import {OutlineButton, SolidButton} from '@/components/Button';
import {BuildingOfficeIcon, GlobeAltIcon, PencilSquareIcon} from '@heroicons/react/24/outline';
import {useUser} from '@lore/auth';
import {useQueryMutation} from '@lore/query-connect';
import React, {useState} from 'react';
import CheckboxField from '../../../forms/_fields_v2/CheckboxField';

export default function OpportunitiesSection() {
  const currentUser = useUser();
  const userMutation = useQueryMutation('currentUser.updateSingleton', currentUser)
  const {virtual, inPerson} = currentUser.data;

  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [savedVirtual, setSavedVirtual] = useState(virtual);
  const [savedInPerson, setSavedInPerson] = useState(inPerson);
  const [editableVirtual, setEditableVirtual] = useState(virtual);
  const [editableInPerson, setEditableInPerson] = useState(inPerson);

  function onEdit() {
    setEditableVirtual(savedVirtual);
    setEditableInPerson(savedInPerson);
    setIsEditing(true);
  }

  function onCancel() {
    setEditableVirtual(savedVirtual);
    setEditableInPerson(savedInPerson);
    setIsEditing(false);
  }

  async function onSave() {
    const prevVirtual = savedVirtual;
    const prevInPerson = savedInPerson;
    try {
      setIsSaving(true);
      setSavedVirtual(editableVirtual);
      setSavedInPerson(editableInPerson);
      await userMutation.mutateAsync({virtual: editableVirtual, inPerson: editableInPerson});
      setIsEditing(false);
    } catch {
      setSavedVirtual(prevVirtual);
      setSavedInPerson(prevInPerson);
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <section id="opportunities" className="py-8">
      <h2 className="mb-8 text-2xl font-semibold text-cs-gray-900">Opportunities</h2>
      {/*<pre>{JSON.stringify(_.pick(currentUser.data, ['virtual', 'inPerson']))}</pre>*/}

      <div className="space-y-4">
        <div className="flex items-start space-x-3">
          <h4 className="text-base font-semibold text-cs-gray-900">What type of opportunities are you open to?</h4>
          {!isEditing && (
            <button
              type="button"
              className="text-cs-blue-500 hover:opacity-60"
              onClick={onEdit}
              aria-label="Edit opportunities"
            >
              <PencilSquareIcon className="mt-0.5 size-5 shrink-0"/>
            </button>
          )}
        </div>

        {isEditing ? (
          <div className="space-y-8">
            <CheckboxField
              label={(
                <div className="flex items-center space-x-1">
                  <GlobeAltIcon className="size-5"/>
                  <span>Virtual</span>
                </div>
              )}
              description="Connect with collaborators within your local community as well as other communities across the nation. You'll have a wider range of opportunities. Virtual also tends to be lower effort."
              checked={editableVirtual}
              onChange={(event) => setEditableVirtual(event.target.checked)}
            />
            <CheckboxField
              label={(
                <div className="flex items-center space-x-1">
                  <BuildingOfficeIcon className="size-5"/>
                  <span>In-person</span>
                </div>
              )}
              description="Connect with collaborators in your local community. These can require a little more effort but tend to have a greater impact on students."
              checked={editableInPerson}
              onChange={(event) => setEditableInPerson(event.target.checked)}
            />
            <div className="mt-4 flex items-center justify-between">
              <OutlineButton label="Cancel" onClick={onCancel} disabled={isSaving}/>
              <SolidButton label="Save" onClick={onSave} disabled={isSaving}/>
            </div>
          </div>
        ) : (
          <div className="space-y-2 text-base text-cs-gray-500">
            {savedVirtual && <p>Virtual</p>}
            {savedInPerson && <p>In-person</p>}
            {!savedVirtual && !savedInPerson && <p>(none selected)</p>}
          </div>
        )}
      </div>
    </section>
  );
}
